// extracted by mini-css-extract-plugin
export default {"root":"ZHWrxww2dg","message":"wj1xEk_K3N","button":"ItYg2ZHITB"};